"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addControls = addControls;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _ToolbarButton = _interopRequireDefault(require("rich-text-lib/components/toolbar/ToolbarButton"));

var _ToolbarButton2 = _interopRequireDefault(require("../components/ToolbarButton"));

var _toolbar = require("../constants/toolbar");

var _ReactButton = require("../controls/ReactButton");

var _usageTracking = require("../utils/usageTracking");

var _usageTracking2 = require("../constants/usageTracking");

var _i18n = require("../utils/i18n");

var i18nKey = (0, _i18n.i18nWithNameSpace)('TinymcePlugins.hsemoji');
var emojiInsertCount = 0;

var getEmojiInsertCount = function getEmojiInsertCount() {
  emojiInsertCount++;
  return emojiInsertCount;
};

var resetEmojiInsertCount = function resetEmojiInsertCount() {
  emojiInsertCount = 0;
};

function addControls(editor, getEmojiToolbarButton) {
  editor.addCommand('hsInsertEmoji', function (_, value) {
    editor.insertContent(value);
    (0, _usageTracking.trackInteraction)(editor, 'tinymceInsertEmoji', _usageTracking2.INSERT_EMOJI, {
      insertCount: getEmojiInsertCount(),
      version: 'v1'
    });
  });

  var trackOpenEmojiPopover = function trackOpenEmojiPopover() {
    resetEmojiInsertCount();
    (0, _usageTracking.trackInteraction)(editor, 'tinymceEmoji', _usageTracking2.OPEN_EMOJI_POPOVER, {
      version: 'v1'
    });
  };

  var getReactElement = function getReactElement(renderButton) {
    return getEmojiToolbarButton(trackOpenEmojiPopover, renderButton);
  };

  editor.addButton('hsemoji', function () {
    return {
      icon: 'hsemoji',
      type: _ReactButton.REACT_BUTTON_TYPE,
      reactElement: getReactElement(function (handleClick, handleMouseEnter) {
        return _react.default.createElement(_ToolbarButton2.default, {
          iconName: "emoji",
          onClick: handleClick,
          onMouseEnter: handleMouseEnter
        });
      }),
      tooltip: i18nKey('tooltip')
    };
  });
  editor.addButton('canvasemoji', {
    type: _toolbar.CANVAS_BUTTON_TYPE,
    renderControl: function renderControl(props) {
      return getReactElement(function (handleClick, handleMouseEnter, open) {
        return _react.default.createElement(_ToolbarButton.default, (0, _extends2.default)({
          iconName: "emoji",
          "data-test-id": "insert-emoji-button",
          tooltip: i18nKey('tooltip'),
          onClick: handleClick,
          onMouseEnter: handleMouseEnter,
          selected: open
        }, props));
      });
    }
  });
}